module.exports = __webpack_public_path__ + "static/media/WaitingPointMarker.63b56971.svg";